import { DpModernProductCardVariant } from '@/components/blocks/DpModernProductCard';
import { ProductCardModern } from '@/components/blocks/ProductCardModern';
import { CLICK_PRODUCT_VIEW_SOURCE } from '@/data/constants/clickProductView';
import { useCarouselProductEvents } from '@/data/Content/_CarouselProductEvents';
import { ProductTypeWithInfoElectronico } from '@/data/Content/_Products_InfoElectronico';
import { ContentContext } from '@/data/context/content';
import { usePDPContext } from '@/data/context/PDP';
import { ID } from '@/data/types/Basic';
import { ProductType } from '@/data/types/Product';
import { FC, useContext, useEffect } from 'react';

export const ProductLiteModern: FC<{
	product: ProductTypeWithInfoElectronico;
	contract?: string;
	variant?: DpModernProductCardVariant;
	clickSource?: CLICK_PRODUCT_VIEW_SOURCE;
	clickAction?: () => void;
	index: number;
	parentPartNumber?: string;
}> = ({ product, contract, variant, clickSource, clickAction, index, parentPartNumber }) => {
	const { onNotify } = useContext(ContentContext) as {
		onNotify: (id: ID, contract: string, product?: ProductType) => void;
	};
	const { product: parentProduct } = usePDPContext();

	const { onClick } = useCarouselProductEvents({
		product,
		index,
		item_list_id: clickSource || 'unknown',
		parentPartNumber,
		parentProduct,
	});

	useEffect(() => {
		if (onNotify && contract) {
			onNotify(product.partNumber, contract, product);
		}
	}, [contract, product, onNotify]);

	return (
		<ProductCardModern
			product={product}
			variant={variant}
			clickSource={clickSource}
			onClick={onClick(clickAction)}
		/>
	);
};
